// ----------------------------------------------------------------------

export default function ToggleButton(theme) {
  return {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius * 1.5,
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '13px',
          padding: '8px 16px',
          minHeight: 36,
          border: `2px solid ${theme.palette.grey[300]}`,
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.paper,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          overflow: 'hidden',
          '&:hover': {
            backgroundColor: `linear-gradient(135deg, ${theme.palette.primary.main}10 0%, ${theme.palette.primary.light}05 100%)`,
            borderColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
            transform: 'translateY(-1px)',
            boxShadow: `0 4px 12px 0 ${theme.palette.primary.main}20`,
          },
          '&.Mui-selected': {
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            color: 'white',
            borderColor: theme.palette.primary.main,
            boxShadow: `0 4px 14px 0 ${theme.palette.primary.main}40`,
            '&:hover': {
              background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
              boxShadow: `0 6px 20px 0 ${theme.palette.primary.main}60`,
              transform: 'translateY(-2px)',
            },
          },
          '&:active': {
            transform: 'translateY(0)',
          },
        }
      }
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          '& .MuiToggleButton-root': {
            margin: 0,
            '&:not(:first-of-type)': {
              marginLeft: -2,
              borderLeft: '2px solid transparent'
            },
            '&:first-of-type': {
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0
            },
            '&:last-of-type': {
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0
            },
            '&:not(:first-of-type):not(:last-of-type)': {
              borderRadius: 0
            }
          }
        }
      }
    }
  };
}
